module.exports = __webpack_public_path__ + "static/media/restart-php.ae18561f.svg";